export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
     * @description 验证验证码
     * @param {Object} data {String} randstr 腾讯验证返回的 randstr
     * @param {Object} data {String} ticket 腾讯验证返回的 ticket
     */
    CAPTCHA_CHECK: function CAPTCHA_CHECK(_ref2) {
      var _ref2$randstr = _ref2.randstr,
          randstr = _ref2$randstr === void 0 ? '' : _ref2$randstr,
          _ref2$ticket = _ref2.ticket,
          ticket = _ref2$ticket === void 0 ? '' : _ref2$ticket;
      return request({
        url: '/api/captcha/check',
        method: 'post',
        data: {
          randstr: randstr,
          ticket: ticket
        }
      });
    }
  };
});